import React from "react";
import styles from "./PageLayout.module.css";

export default function PageLayout({ header, children, stats, controls }) {
  return (
    <div className={styles.page}>
      {header && <div className={styles.header}>{header}</div>}

      {/* Обе панели идут в одной сетке */}
      <div className={styles.panels}>
        {controls && controls}
        {stats && stats}
      </div>

      <div className={styles.content}>{children}</div>
    </div>
  );
}
